import React, { useState, useEffect } from 'react';
import { ArrowUp } from '@phosphor-icons/react';

export function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  if (!visible) return null;

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-6 right-6 z-50 w-12 h-12 rounded-full bg-pp-navy text-white shadow-lg hover:bg-pp-navy-dark transition-all hover:scale-105 flex items-center justify-center"
      aria-label="Scroll to top"
      data-testid="scroll-to-top"
    >
      <ArrowUp size={20} weight="bold" />
    </button>
  );
}
